module.exports = __webpack_public_path__ + "static/img/12h.d3d174a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/12h.svg
// module id = 4043
// module chunks = 1